module.exports = __webpack_public_path__ + "img/food_07.bacfc58d.jpg";